export const ROUTE_QUIZ_INTRO = '/quiz/intro/';
export const ROUTE_QUIZ_BUDGET = '/quiz/budget/';
export const ROUTE_QUIZ_BUDGET_BENEFITS = '/quiz/budget-benefits/';
export const ROUTE_HELLO = '/quiz/hello/';
export const ROUTE_GOALS = '/quiz/hello/goals/';
export const ROUTE_GOALS_BENEFITS = '/quiz/goals-benefits/';
export const ROUTE_EATING_HABITS = '/quiz/eating-habits/';
export const ROUTE_EATING_HABITS_DIETARY_NEEDS =
  '/quiz/eating-habits/dietary-needs/';
export const ROUTE_MACRO_NUTRIENT = '/quiz/macro-nutrient/';
export const ROUTE_MACRO_NUTRIENT_LOW_SODIUM =
  '/quiz/macro-nutrient/low-sodium/';
export const ROUTE_FOOD_QUALITIES = '/quiz/food-qualities/';
export const ROUTE_FOOD_FORMATS = '/quiz/food-formats/';
export const ROUTE_CUISINES = '/quiz/cuisines/';
export const ROUTE_FLAVORS = '/quiz/flavors/';
export const ROUTE_MEAT = '/quiz/meat/';
export const ROUTE_SEAFOOD = '/quiz/seafood/';
export const ROUTE_PLANTS = '/quiz/plants/';
export const ROUTE_POLARIZING = '/quiz/polarizing/';
export const ROUTE_FOOD_PREFERENCES_INTRO = '/quiz/food-preferences-intro/';
export const ROUTE_BREAKFAST = '/quiz/breakfast/';
export const ROUTE_BREAKFAST_FREQUENCY = '/quiz/breakfast/frequency/';
export const ROUTE_READY_MADE = '/quiz/ready-made/';
export const ROUTE_SNACKS = '/quiz/snacks/';
export const ROUTE_SNACKS_FREQUENCY = '/quiz/snacks/frequency/';
export const ROUTE_SWEETS = '/quiz/sweets/';
export const ROUTE_SWEETS_FREQUENCY = '/quiz/sweets/frequency/';

export const ROUTE_QUIZ_LUNCH = '/quiz/lunch/';
export const ROUTE_QUIZ_LUNCH_FREQUENCY = '/quiz/lunch/frequency/';
export const ROUTE_QUIZ_DINNER = '/quiz/dinner/';
export const ROUTE_QUIZ_DINNER_FREQUENCY = '/quiz/dinner/frequency/';

/*
  This list represents ALL possible permutations of the quiz.

  Any route that CAN be in the quiz MUST be defined here.
  Filtering and refining the route list is handled in
  'use-quiz-routes.ts'

  DO NOT EXCLUDE ROUTES that may be filtered at runtime- eg, skip meat if vegetarian.
  That logic is handled downstream.

*/
export const ROUTE_SEQUENCES = {
  base: [
    ROUTE_QUIZ_INTRO,
    ROUTE_HELLO,
    ROUTE_GOALS,
    ROUTE_GOALS_BENEFITS,
    ROUTE_QUIZ_BUDGET,
    ROUTE_QUIZ_BUDGET_BENEFITS,
    ROUTE_EATING_HABITS,
    ROUTE_EATING_HABITS_DIETARY_NEEDS,
    ROUTE_MACRO_NUTRIENT,
    ROUTE_MACRO_NUTRIENT_LOW_SODIUM,
    ROUTE_FOOD_QUALITIES,
    ROUTE_FOOD_FORMATS,
    ROUTE_CUISINES,
    ROUTE_FLAVORS,
    ROUTE_MEAT,
    ROUTE_SEAFOOD,
    ROUTE_PLANTS,
    ROUTE_POLARIZING,
    ROUTE_FOOD_PREFERENCES_INTRO,
    ROUTE_BREAKFAST,
    ROUTE_BREAKFAST_FREQUENCY,
    ROUTE_QUIZ_LUNCH,
    ROUTE_QUIZ_LUNCH_FREQUENCY,
    ROUTE_QUIZ_DINNER,
    ROUTE_QUIZ_DINNER_FREQUENCY,
    ROUTE_SNACKS,
    ROUTE_SNACKS_FREQUENCY,
    ROUTE_SWEETS,
    ROUTE_SWEETS_FREQUENCY,
  ],
} as const;

export const LUNCH_REFRESH_ROUTES = [
  ROUTE_QUIZ_LUNCH,
  ROUTE_QUIZ_LUNCH_FREQUENCY,
  ROUTE_QUIZ_DINNER,
  ROUTE_QUIZ_DINNER_FREQUENCY,
] as const;

const routeSequenceKeys = Object.keys(ROUTE_SEQUENCES) as Array<
  keyof typeof ROUTE_SEQUENCES
>;
export const allQuizRoutes = routeSequenceKeys.reduce((acc, key) => {
  const sequence = ROUTE_SEQUENCES[key];
  sequence.forEach((route) => {
    if (acc.indexOf(route) === -1) {
      acc.push(route);
    }
  });

  return acc;
}, [] as AllQuizRoutes[]);

export type AllQuizRoutes =
  (typeof ROUTE_SEQUENCES)[keyof typeof ROUTE_SEQUENCES][number];
export const STARTING_ROUTE = ROUTE_SEQUENCES.base[0];
export const LAST_ROUTE = ROUTE_SEQUENCES.base[ROUTE_SEQUENCES.base.length - 1];
